export const LPpages = [
    "/landing-page/corporate-gifting",

]